<div class="edition-container">
  <mat-drawer-container *ngIf="learnspace?.courses" class="layout reporting-container">
    <mat-drawer mode="side" opened class="sidebar">
      <ng-container *ngFor="let course of sortCourses(learnspace.courses)">
        <mat-expansion-panel class="reporting-expansion-panel" [expanded]="course.id === activeCourseId" togglePosition="before">
          <mat-expansion-panel-header [@.disabled]="true" [class.active]="course.id === activeCourseId">
            <mat-panel-title class="text-truncate">{{ course.title }}</mat-panel-title>
          </mat-expansion-panel-header>
  
          <mat-nav-list>
            <mat-list-item (click)="goToCourse(course.id, 'reports')" [class.active]="course.id === activeCourseId && activeMode === 'reports'">
              <mat-icon fontSet="fa" fontIcon="fa-award"></mat-icon>
              REPORTS
            </mat-list-item>
            <mat-list-item (click)="goToCourse(course.id, 'sessions')" [class.active]="course.id === activeCourseId && activeMode === 'sessions'">
              <mat-icon fontSet="fa" fontIcon="fa-file"></mat-icon>
              SESSIONS
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>
      </ng-container>
    </mat-drawer>

    <mat-drawer-content class="content">
      <ng-container *ngIf="activeCourse">
        <ng-container *ngIf="activeMode === 'reports'; else sessions">
          <program-reporting-reports [course]="activeCourse" (onOpenSessionLog)="onOpenSessionLog($event)"></program-reporting-reports>
        </ng-container>
        <ng-template #sessions>
          <program-reporting-sessions [course]="activeCourse" (onOpenSessionLog)="onOpenSessionLog($event)"></program-reporting-sessions>
        </ng-template>
      </ng-container>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
